import { TrendingUp, TrendingDown } from "lucide-react";

const VARIANT_TONE = { green: "text-up", red: "text-down", yellow: "", blue: "", purple: "", cyan: "" };

export default function KpiCard({ label, value, delta, deltaLabel, icon: Icon, variant = "yellow", testid }) {
  const positive = typeof delta === "string" && delta.trim().startsWith("+");
  const negative = typeof delta === "string" && delta.trim().startsWith("-");
  return (
    <div className="min-w-0 rounded-xl border border-border bg-surface/50 px-4 py-3" data-testid={testid}>
      <div className="flex items-center justify-between gap-2">
        <p className="truncate text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{label}</p>
        {Icon && <Icon className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />}
      </div>
      <p className={`num mt-1 truncate text-2xl font-semibold ${VARIANT_TONE[variant] || ""}`} title={typeof value === "string" ? value : undefined}>
        {value}
      </p>
      {(delta || deltaLabel) && (
        <div className="mt-0.5 flex items-center gap-1 text-xs">
          {delta && (
            <span className={`inline-flex items-center gap-0.5 font-medium ${positive ? "text-up" : negative ? "text-down" : "text-muted-foreground"}`}>
              {positive && <TrendingUp className="h-3 w-3" />}
              {negative && <TrendingDown className="h-3 w-3" />}
              {delta}
            </span>
          )}
          {deltaLabel && <span className="truncate text-muted-foreground">{deltaLabel}</span>}
        </div>
      )}
    </div>
  );
}
